// import React from 'react'

// function LeaseContract() {
//   return <div>222</div>
// }

// export default LeaseContract

// import React from 'react'

// function LeaseContract() {
//   return <div>11</div>
// }

// export default LeaseContract
import '@src/assets/style/main.scss'
import EndlessList from '@src/component/endlessList'
import {
	AlertModal,
	ConfirmModal,
	LoadingModal,
	PushConfirmModal
} from '@src/component/IModal'
import {formatString} from '@src/constant'
import {goto} from '@src/route'
import CommonService from '@src/service/commonService'
import {isEmpty} from '@src/util'
import {Picker, Toast} from 'antd-mobile-v2'
import moment from 'moment'
import React from 'react'
import {Subject} from 'rxjs'
import {throttleTime, debounceTime} from "rxjs";


const CaseType = [
	{value: 0, label: '未下发'},
	{value: 1, label: '已驳回'},
	{value: 2, label: '待客户确认'},
	{value: 3, label: '已拒绝'},
	{value: 4, label: '待审核'},
	{value: 5, label: '审核通过'},
	{value: 6, label: '已终止'},
	{value: 7, label: '已结束'},
]

const Status = [
	{value: 0, label: '处理中'},
	{value: 1, label: '已完成'},
	{value: 6, label: '已终止'},
	{value: 7, label: '已结束'},
]

const contractInfoStatus = [
	{value: 0, label: '未推送'},
	{value: 1, label: '待签字'},
	{value: 4, label: '已驳回'},
	{value: 88, label: '已过期'},
]

export type QueryResultType = { list: Array<any>; total: number }

export type QueryType = {
	page: number
	content?: string
	status?: number
	LeaseContractStatus: number
}

type LeaseContractPropsType = {
	action?: (params: QueryType) => QueryResultType | Promise<QueryResultType>
	hide?: boolean
}

type LeaseContractStateType = {
	page: number
	list: any[]
	total: number
	params: {
		content: string
		status?: number
		date?: any
		contractInfoStatus: number
	}
	loading?: boolean
	visible?: boolean
	reasonVisible?: boolean
	selectVisible?: boolean
	loadingVisible?: boolean,
	pushing?: boolean
}
const queryParam = {
	id: 0,
	beforeStatus: 0,
}

let currentId = 0
let reason = ''

export default class LeaseContract extends React.Component<LeaseContractPropsType,
	LeaseContractStateType> {
	ref?: any
	containerRef?: any
	datePickerRef?: any
	contactSubObj = new Subject()

	constructor(props: LeaseContractPropsType) {
		super(props)
		this.state = {
			page: 0,
			list: [],
			total: 0,
			params: {
				content: '',
				contractInfoStatus: -1,
			},
			visible: false,
			reasonVisible: false,
			selectVisible: false,
			loadingVisible: false,
			pushing: false
		}
		this.contactSubObj.pipe(throttleTime(3000)).subscribe(() => {
			this.okConfirm()
		})
	}

	async onRefresh(state?: LeaseContractStateType) {
		const {list, total, page, params} = state || this.state
		if (total && list.length >= total) {
			return
		}
		const newPage = page + 1
		const param: any = {
			...params,
			pages: newPage,
		}
		if (isEmpty(param.content)) {
			delete param.content
		}
		const {action} = this.props
		if (!action || typeof action !== 'function') {
			return
		}
		this.setState({loading: true})
		let data = action(param)
		if (data instanceof Promise) {
			data = await data
		}
		this.setState({loading: false})
		if (data) {
			let _list: any[] = data.list || []
			const _total = data.total || 0
			_list = list.concat(_list)
			this.setState({total: _total, list: _list, page: newPage})
		} else {
			Toast.fail('数据加载失败...')
		}
	}

	componentDidMount() {
		this.onRefresh()
	}

	UNSAFE_componentWillReceiveProps(nextProps: LeaseContractPropsType) {
		if (nextProps.hide !== this.props.hide && nextProps.hide === false) {
			const {params} = this.state
			const state = {params, page: 0, list: [], total: 0}
			this.setState(state)
			this.onRefresh(state)
			this.containerRef?.querySelector('div').scrollTo({top: 0})
		}
	}

	filterItemChange(type: 'status' | 'contractInfoStatus', value: any) {
		const {params} = this.state
		if (type === 'status') {
			params.status = value
		} else if (type === 'contractInfoStatus') {
			params.contractInfoStatus = value
		}

		const state = {params, page: 0, list: [], total: 0}
		this.setState(state)
		this.onRefresh(state)
		this.containerRef?.querySelector('div').scrollTo({top: 0})
	}

	allStatus(array: Array<{ label: string; value: any }>) {
		return [{value: -1, label: '全部'}].concat(array)
	}

	statusText(array: Array<{ label: string; value: any }>, status: any) {
		return array.find((e) => e.value == status)?.label || '全部'
	}

	// 编辑状态
	centerEditStatus(val: string) {
		CommonService.editStatus({
			loaningInfoId: queryParam.id.toString(),
			status: '6',
			reason: val,
			beforeStatus: queryParam.beforeStatus.toString(),
		}).then(() => {
			const {params} = this.state
			const state = {params, page: 0, list: [], total: 0, visible: false}
			this.setState(state)
			this.onRefresh(state)
			this.containerRef?.querySelector('div').scrollTo({top: 0})
		})
	}

	// 填写原因
	showModal(id: number, beforeStatus: number) {
		this.setState({visible: true})
		queryParam.id = id
		queryParam.beforeStatus = beforeStatus
	}

	// 查看原因
	showConfirm(val: number) {
		this.setState({
			selectVisible: true,
		})
		currentId = val
	}

	onOkConfirmHandle() {
		this.contactSubObj.next(null)
	}

	okConfirm() {
		if (this.state.pushing) {
			return
		}
		this.setState({
			pushing: true,
			loadingVisible: true
		})
		CommonService.pushContrack({loaningInfoId: currentId})
			.then(() => {
				const {params} = this.state
				const state = {
					params,
					page: 0,
					list: [],
					total: 0,
					selectVisible: false,
					loadingVisible: false,
					pushing: false
				}
				this.setState(state)
				this.onRefresh(state)
				this.containerRef?.querySelector('div').scrollTo({top: 0})
				Toast.show('操作成功')
			})
			.catch((err) => {
				Toast.show(err)
				this.setState({
					selectVisible: false,
					loadingVisible: false,
					pushing: false
				})
			})
	}

	showReason(val: string) {
		reason = val
		this.setState({reasonVisible: true})
	}

	render() {
		const {
			list,
			params,
			loading,
			total,
			visible,
			reasonVisible,
			selectVisible,
			loadingVisible,
			pushing
		} = this.state
		const {hide} = this.props
		const noMore = list.length >= total

		return (
			<>
				{loadingVisible && (
					<LoadingModal visible={loadingVisible} text="合同推送中"/>
				)}
				{selectVisible && (
					<ConfirmModal
						visible={selectVisible}
						onOk={this.onOkConfirmHandle.bind(this)}
						okText={pushing ? '推送中' : '确认'}
						content="确认将相关合同推送给用户签字?"
						onCancel={() => this.setState({selectVisible: false})}
					/>
				)}
				{visible && (
					<PushConfirmModal
						visible={visible}
						onOk={this.centerEditStatus.bind(this)}
						onCancel={() => this.setState({visible: false})}
					/>
				)}
				{reasonVisible && (
					<AlertModal
						visible={reasonVisible}
						title="原因"
						content={<div style={{textAlign: 'center'}}>{reason}</div>}
						onOk={() => this.setState({reasonVisible: false})}
					/>
				)}
				<div className="m-tab" style={{display: hide ? 'none' : 'flex'}}>
					<div className="m-query-bar">
						{/* 手机号 */}
						<div className="m-row">
							<input
								className="input"
								value={params.content}
								placeholder="请输入姓名/手机号搜索"
								onChange={(e) => {
									const value = e.target.value
									if (isEmpty(value)) {
										params.content = ''
									} else {
										params.content = value
									}
									this.setState({params})
								}}
							/>
							<div
								className="btn-search"
								onClick={() => {
									const params = this.state.params
									const state = {params, page: 0, list: [], total: 0}
									this.onRefresh(state)
								}}
							>
								搜索
							</div>
						</div>
						{/* 分类选择 */}
						<div className="m-row">
							<div className="m-filter-item">
								<span className="btn-selector-label">状态:</span>
								<Picker
									data={this.allStatus(contractInfoStatus)}
									value={
										params.contractInfoStatus || params.contractInfoStatus === 0
											? [params.contractInfoStatus]
											: undefined
									}
									extra="全部"
									cols={1}
									onChange={(e) => {
										let statusValue: any
										if (e && e.length > 0) {
											const value: any = e[0]
											// if (value === -1) {
											//   statusValue = undefined
											// } else {
											//   statusValue = value
											// }
											statusValue = value
										} else {
											statusValue = undefined
										}
										this.filterItemChange('contractInfoStatus', statusValue)
									}}
								>
                  <span className="btn-selector-value">
                    {this.statusText(
						contractInfoStatus,
						params.contractInfoStatus
					)}
                  </span>
								</Picker>
							</div>
						</div>
					</div>
					{/* list body */}
					<div className="m-body" ref={this.containerRef}>
						<EndlessList
							onTouchBottom={this.onRefresh.bind(this)}
							loading={loading}
							noMore={noMore}
						>
							<div className="m-list">
								{list.map((e, i) => {
									return (
										<RenderItem
											data={e}
											key={i}
											show={this.showModal.bind(this)}
											showConfirm={this.showConfirm.bind(this)}
											showReason={this.showReason.bind(this)}
										/>
									)
								})}
							</div>
						</EndlessList>
					</div>
				</div>
			</>
		)
	}
}

export function RenderItem(props: {
	data: any
	show: (id: number, beforeStatus: number) => void
	showConfirm: (val: number) => void
	showReason: (val: string) => void
}) {
	const {data, show, showConfirm, showReason} = props

	const action = () => {
		if (data.status === 0) {
			show(data.loaningInfoId, data.status)
		} else {
			// goto('/view-contract', {
			//   id: data.id,
			// })
			CommonService.getContrackDetail({
				loaningInfoId: data.loaningInfoId,
			}).then(
				(res: any) => {
					if (res && res.rejectReason) {
						showReason(res.rejectReason)
					}
				}
			)
		}
	}

	const toDetail = () => {
		if (data.contractInfoStatus === 0) {
			showConfirm(data.loaningInfoId)
			return
		}
		goto('/view-contract', {
			id: data.loaningInfoId,
		})
	}

	const toPlan = () => {
		if (data.financePlanStatus === 0) {
			goto('/plan-detail-edit', {
				uuserName: data.insuredName,
				id: data.loaningInfoId,
				status: data.financePlanStatus,
				source: data.source,
				rate: data.finalRate,
				earnestmoneypercent: data.earnestMoneyPercent,
				firstpaidpercent: data.firstPaidPercent,
				experiment: data.experiment,
				price:data.netPrice,
				stage:data.stage
			})
			return
		}
		goto('/plan-detail', {
			userName: data.insuredName,
			id: data.loaningInfoId,
			status: data.financePlanStatus,
			source: data.source,
            experiment: data.experiment,
			rate: isEmpty(data.finalRate) || '0',
			earnestmoneypercent: isEmpty(data.earnestMoneyPercent) || '0',
			firstpaidpercent: data.firstPaidPercent
		})
	}

	return (
		<div className="m-list-item">
			<div className="row">
				<div className="label name">{data.insuredName}</div>
				<div className="value">{data.mobile}</div>
			</div>
			<div className="row">
				<div className="label" style={{whiteSpace: 'nowrap'}}>
					复审通过时间
				</div>
				<div className="value">
					{data.loanPassTime && moment(data.loanPassTime).format(formatString)}
				</div>
			</div>
			<div className="row">
				<div className="label">申请车型</div>
				<div className="value">
					{data.brandName}+{data.vehicleName}
				</div>
			</div>
			<div className="row">
				<div className="label">跟单销售</div>
				<div className="value">{data.saleName}</div>
			</div>
			<div className="row">
				<div className="label">金融方案</div>
				<div style={{paddingLeft: 6, color: '#6291DF'}} onClick={toPlan}>
					{[0].includes(data.financePlanStatus) && '确认金融方案'}
					{data.financePlanStatus !== 0 && '查看金融方案'}

					{`>>`}
				</div>
			</div>
			<div className="row">
				<div className="label">状态</div>
				<div className="value">
					{
						contractInfoStatus.find(
							(item) => item.value === data.contractInfoStatus
						)?.label
					}
				</div>
				{ // 背户-否
					data.registeredByOthers !== 1 ? (
							<div
								style={{paddingLeft: 6, color: '#6291DF'}}
								onClick={toDetail}
							>
								{[0].includes(data.contractInfoStatus) && '推送相关合同>>'}
								{data.contractInfoStatus !== 0 && '查看相关合同>>'}
							</div>
						) : (
							<>
								{data.needGuarantor === 1 && <span>（担保人-是）</span>}
								{data.registeredByOthers === 1 && <span>（背户-是）</span>}
							</>
						)}
			</div>
			{data.uptime && (
				<div className="row">
					<div className="label">更新时间</div>
					<div className="value">
						{moment(data.uptime).format(formatString)}
					</div>
				</div>
			)}
		</div>
	)
}
